"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var talkTime_styles_1 = require("./talkTime.styles");
var core_components_1 = require("@securityproducts/core-components");
var talkTime_i18n_1 = require("./talkTime.i18n");
exports.TalkTime = function (props) {
    var strings = core_components_1.useLocalisation(talkTime_i18n_1.talkTimeTranslations, props.language);
    var infoText = React.createElement("div", { className: talkTime_styles_1.tooltip }, strings.infoText);
    var average = {
        name: strings.average,
        data: props.average,
        type: "line",
    };
    var maximum = {
        name: strings.maximum,
        data: props.maximum,
        type: "line",
    };
    return (React.createElement("div", { className: talkTime_styles_1.chartWrapper },
        React.createElement(core_components_1.AverageMaximumChart, { id: "talk-time-chart", heading: strings.talkTime, data: [average, maximum], info: infoText, displayRange: props.display, language: props.language, timezone: props.timezone })));
};
exports.TalkTime.defaultProps = {
    maximum: [],
    average: [],
    display: "DAYS",
};
